import { TEndpoint } from './../config/endpoint.config';
import httpInstance from '../config/http.config';
import { getPathParams, replacePathParams } from '../utils/NavigateWithParams';
import _ from 'lodash';

export default class HttpService {
  get(endpoint: TEndpoint, options?: { params?: any; silently?: boolean }) {
    const params = options ? (options.params ? options.params : {}) : {};
    const silently = options
      ? options.silently
        ? options.silently
        : false
      : false;
    const { url, parsedParams } = this.manageParams(endpoint, params);
    return httpInstance.get(url, {
      params: parsedParams,
      headers: { silently: !!silently },
    });
  }

  post(
    endpoint: TEndpoint,
    body: any,
    options?: { params?: any; silently?: boolean },
  ) {
    const params = options ? (options.params ? options.params : {}) : {};
    const silently = options
      ? options.silently
        ? options.silently
        : false
      : false;
    const { url, parsedParams } = this.manageParams(endpoint, params);
    return httpInstance.post(url, body, {
      params: parsedParams,
      headers: { silently: !!silently },
    });
  }

  patch(
    endpoint: TEndpoint,
    body: any,
    options?: { params?: any; silently?: boolean },
  ) {
    const params = options ? (options.params ? options.params : {}) : {};
    const silently = options
      ? options.silently
        ? options.silently
        : false
      : false;
    const { url, parsedParams } = this.manageParams(endpoint, params);
    return httpInstance.patch(url, body, {
      params: parsedParams,
      headers: { silently: !!silently },
    });
  }

  put(
    endpoint: TEndpoint,
    body: any,
    options?: { params?: any; silently?: boolean },
  ) {
    const params = options ? (options.params ? options.params : {}) : {};
    const silently = options
      ? options.silently
        ? options.silently
        : false
      : false;
    const { url, parsedParams } = this.manageParams(endpoint, params);
    return httpInstance.put(url, body, {
      params: parsedParams,
      headers: { silently: !!silently },
    });
  }

  delete(endpoint: TEndpoint, options?: { params?: any; silently?: boolean }) {
    const params = options ? (options.params ? options.params : {}) : {};
    const silently = options
      ? options.silently
        ? options.silently
        : false
      : false;
    const { url, parsedParams } = this.manageParams(endpoint, params);
    return httpInstance.delete(url, {
      params: parsedParams,
      headers: { silently: !!silently },
    });
  }

  private manageParams(endpoint: string, params?: any) {
    const pathParams = getPathParams(endpoint);
    const url = replacePathParams(endpoint, params);
    const parsedParams = this.removePathParamsInParams(params, pathParams);
    return { url, parsedParams };
  }

  private removePathParamsInParams(params: any, pathParams: any) {
    const parsedParams: any = {};
    if (!params) {
      return parsedParams;
    }
    const keys = Object.keys(params);
    const paramsKeys = keys.filter(
      (key: string) => !_.find(pathParams, (pp: string) => pp === key),
    );
    paramsKeys.forEach(pk => (parsedParams[pk] = params[pk]));
    return parsedParams;
  }
}
